export default __webpack_public_path__ + "static/media/149.2ad57802.jpg";